module.exports = __webpack_public_path__ + "img/8a91294.jpg";